import { GeneralApiArgs } from 'common/models/crypto';
import { Nullable } from 'common/models/optional';
import { StorageUtils } from './storageUtils';
import { waitForTransaction as wft } from '@wagmi/core';
import { Address, TransactionReceipt } from 'viem';

export namespace ContractUtils {
  // https://support.kraken.com/hc/en-us/articles/203325283-Cryptocurrency-deposit-processing-times
  const confirmationsRequired = 3;

  export async function simpleWaitForTransaction(
    hash: string
  ): Promise<Nullable<TransactionReceipt>> {
    return (
      (await wft({
        hash: hash as Address,
        confirmations: confirmationsRequired,
      })) || null
    );
  }

  export async function waitForTransaction(
    args: GeneralApiArgs & StorageUtils.FunctionNameArg & StorageUtils.TxHashArg
  ): Promise<Nullable<TransactionReceipt>> {
    const receipt =
      (await wft({
        hash: args.hash as Address,
        confirmations: confirmationsRequired,
      })) || null;
    // Ensure to remove the tx so it's no longer checked in the mintMachine.ts
    await StorageUtils.removeTx(args);
    return receipt;
  }

  export async function waitForTransactionBoolean(
    args: GeneralApiArgs & StorageUtils.FunctionNameArg & StorageUtils.TxHashArg
  ): Promise<boolean> {
    const receipt =
      (await wft({
        hash: args.hash as Address,
        confirmations: confirmationsRequired,
      })) || null;
    // Ensure to remove the tx so it's no longer checked in the Machine
    await StorageUtils.removeTx(args);

    if (receipt?.status === 'success') {
      // success
      console.debug(`Prior tx [${args.hash}] succeeded!`, receipt);
      return true;
    }
    console.error(`Prior tx [${args.hash}] failed, please retry.`, receipt);
    return false;
  }
}
